export const loginHero = {
  headline: "Recovering Debt, Protecting",
  headlineAccent: "Relationship",
  subtitle:
    "Unified CRM & dialer insights — smarter decisions, stronger performance.",
};

export const loginTags = [
  { icon: "mdi-chart-line", label: "Real-time Analytics" },
  { icon: "mdi-phone-in-talk", label: "Smart Dialer" },
  { icon: "mdi-shield-check", label: "Secure Workspace" },
];

export const loginFeatures = [
  {
    icon: "mdi-tune-vertical",
    title: "Call Automation",
    tag: "Outbound at scale",
  },
  {
    icon: "mdi-layers-triple",
    title: "Lead Prioritization",
    tag: "High-intent first",
  },
  {
    icon: "mdi-graph",
    title: "Campaign Control",
    tag: "ROI-focused outreach",
  },
  {
    icon: "mdi-chart-timeline-variant",
    title: "Live Dashboards",
    tag: "Instant visibility",
  },
  {
    icon: "mdi-diamond-stone",
    title: "Data Curation",
    tag: "Clean records",
  },
  {
    icon: "mdi-microphone",
    title: "Call Recording",
    tag: "Compliant capture",
  },
];

export const loginFooterStats = [
  { value: "6+", label: "Core modules" },
  { value: "24/7", label: "Live insights" },
];

export const loginFloaters = [
  { icon: "mdi-phone-in-talk" },
  { icon: "mdi-chart-line" },
  { icon: "mdi-account-group" },
  { icon: "mdi-bullhorn" },
  { icon: "mdi-database" },
  { icon: "mdi-view-dashboard" },
  { icon: "mdi-graph" },
  { icon: "mdi-shield-check" },
];
